/** @jsx jsx */
import { Paragraph } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

interface NoDataProps {}

export const NoData: FC<NoDataProps> = ({}) => {
  const { t } = useTranslation("public");

  return (
    <Paragraph size="p-md" color="n500">
      {t("COMPONENTS.NO_DATA.NONE")}
    </Paragraph>
  );
};
